import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { deleteSysOperationRecord as _deleteSysOperationRecord, getSysOperationRecordList, deleteSysOperationRecordByIds } from '@/api/sysOperationRecord'; //  此处请自行替换地址
import { formatTimeToStr } from '@/utils/data';
import infoList from '@/components/mixins/infoList';
export default {
  name: 'SysOperationRecord',
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getSysOperationRecordList,
      dialogFormVisible: false,
      visible: false,
      type: '',
      deleteVisible: false,
      multipleSelection: [],
      formData: {
        ip: null,
        method: null,
        path: null,
        status: null,
        latency: null,
        agent: null,
        error_message: null,
        user_id: null
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  methods: {
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onDelete: function () {
      var _onDelete = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ids, res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ids = [];
              this.multipleSelection && this.multipleSelection.map(function (item) {
                ids.push(item.ID);
              });
              _context.next = 1;
              return deleteSysOperationRecordByIds({
                ids: ids
              });
            case 1:
              res = _context.sent;
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
                this.deleteVisible = false;
                this.getTableData();
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onDelete() {
        return _onDelete.apply(this, arguments);
      }
      return onDelete;
    }(),
    deleteSysOperationRecord: function () {
      var _deleteSysOperationRecord2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.visible = false;
              _context2.next = 1;
              return _deleteSysOperationRecord({
                ID: row.ID
              });
            case 1:
              res = _context2.sent;
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
                this.getTableData();
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function deleteSysOperationRecord(_x) {
        return _deleteSysOperationRecord2.apply(this, arguments);
      }
      return deleteSysOperationRecord;
    }(),
    fmtBody: function fmtBody(value) {
      try {
        return JSON.parse(value);
      } catch (err) {
        return value;
      }
    }
  },
  created: function created() {
    this.getTableData();
  }
};